import { render } from "./confirm-password.vue?vue&type=template&id=f66bb914"
import script from "./confirm-password.vue?vue&type=script&lang=js"
export * from "./confirm-password.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/auth/confirm-password.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f66bb914"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f66bb914', __exports__)) {
    console.log('reload')
    api.reload('f66bb914', __exports__)
  }
  
  module.hot.accept("./confirm-password.vue?vue&type=template&id=f66bb914", () => {
    console.log('re-render')
    api.rerender('f66bb914', render)
  })

}


export default __exports__